import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionControlIcon from 'components/atoms/icons/subscriptionControlIcon';
import PatientControlButton from 'components/atoms/patentControlButton';
import { useEmailSubscriptionStatus } from 'infrastructure/hooks/control-panel';
import EmailsResubscriptionModal from 'components/molecules/resubscribeToEmails/modal';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const EmailSubscriptionControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const { patientInfo, isCombinedModule, isReadOnlyRole, isCcmActionDisabled } =
    useAccess({
      module,
      patientGuid,
    });

  const { updateSubscriptionStatus, subscriptionStatusLoading } =
    useEmailSubscriptionStatus({
      patientGuid,
      onSuccess() {
        setOpen(false);
      },
    });

  const status = patientInfo?.emailSubscription
    ? t('labels.subscribed')
    : t('labels.unsubscribed');

  const disabled =
    (isCombinedModule && isReadOnlyRole) ||
    patientInfo?.emailSubscription ||
    isCcmActionDisabled;

  return (
    <>
      <PatientControlButton
        label={t('labels.emailSubscription')}
        Icon={SubscriptionControlIcon}
        loading={subscriptionStatusLoading}
        status={status}
        disabled={disabled}
        handleClick={() => setOpen(true)}
      />
      <EmailsResubscriptionModal
        setIsOpen={setOpen}
        isOpen={open}
        loading={subscriptionStatusLoading}
        onSubmit={async (d) => updateSubscriptionStatus(d)}
      />
    </>
  );
};

export default EmailSubscriptionControl;
